// Token được gửi tự động qua httpOnly cookie, không cần header thủ công
export default function authHeader() {
    return {};
}
